import Vue from "vue"
import App from "./modules/Root/App"
import router from './router/index'
import 'Styles/main.scss'
import Quasar, {
  QBtn,
  QSpace,
  QInput,
  QForm,
  QCard,
  QIcon,
  QSelect,
  QTab,
  QTabPanel,
  QTabPanels,
  QTabs,
  QSeparator,
  QTable,
  QTh,
  QTr,
  QTd,
  QPagination,
  QField,
  QFile,
  QStepper,
  QStep,
  QStepperNavigation,
  QDialog,
  ClosePopup,
  QCardSection,
  QCardActions,
  QMenu,
  QItem,
  QItemSection,
  QList,
  QExpansionItem,
  QRadio,
  QDate,
  QPopupProxy,
  QLayout,
  QPageContainer,
  QImg,
  QDrawer,
  QScrollArea,
  Ripple,
  QHeader,
  QToolbar,
  QAvatar,
  QToolbarTitle,
  QToggle,
  QInnerLoading
} from 'quasar'

Vue.use(Quasar, {
  config: {
    brand: {
      primary: '#4694dd',
      secondary: '#ffa35f'
    }
  },
  components: {
    QCard,
    QSpace,
    QBtn,
    QInput,
    QForm,
    QIcon,
    QSelect,
    QTab,
    QTabPanel,
    QTabPanels,
    QTabs,
    QSeparator,
    QTable,
    QTh,
    QTr,
    QTd,
    QPagination,
    QField,
    QFile,
    QStepper,
    QStep,
    QStepperNavigation,
    QDialog,
    QCardSection,
    QCardActions,
    QMenu,
    QItem,
    QItemSection,
    QList,
    QExpansionItem,
    QRadio,
    QDate,
    QPopupProxy,
    QLayout,
    QPageContainer,
    QImg,
    QDrawer,
    QScrollArea,
    QHeader,
    QToolbar,
    QAvatar,
    QToolbarTitle,
    QToggle,
    QInnerLoading
  },
  directives: {
    ClosePopup,
    Ripple
  }
})


new Vue({
  router,
  render: h => h(App)
}).$mount("#root");
